module.exports = "h2.login-title {\n  text-align: center;\n  margin-top: 0; }\n\n.sign-up-form .btn-submit {\n  float: right;\n  margin-bottom: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/user/sign-up/sign-up.component.scss
// module id = ./src/app/pages/user/sign-up/sign-up.component.scss
// module chunks = main